"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const store_1 = __importDefault(require("@/store"));
const vue_1 = require("vue");
const ImageLoader_1 = require("@/classes/ImageLoader");
class Results {
    constructor() {
        this.userName = (0, vue_1.computed)(() => {
            return store_1.default.getters.userName();
        });
        this.coverImageUrl = (0, vue_1.computed)(() => {
            if (!this.firstResult.value) {
                return;
            }
            return ImageLoader_1.ImageLoader.getCountryCoverImageUrl(this.firstResult.value.iso);
        });
        this.portalURL = (0, vue_1.computed)(() => {
            return store_1.default.getters.preferredPortalUrl();
        });
        this.searchURL = (0, vue_1.computed)(() => {
            return store_1.default.getters.portalSearchPath();
        });
        this.allResults = (0, vue_1.computed)(() => {
            return store_1.default.getters.results();
        });
        this.topResults = (0, vue_1.computed)(() => {
            const storeResults = this.allResults.value;
            if (!storeResults || !storeResults.length) {
                return [];
            }
            const results = [...storeResults];
            results.length = 4;
            return results;
        });
        this.firstResult = (0, vue_1.computed)(() => {
            const topResults = this.topResults.value;
            if (!topResults) {
                return null;
            }
            return topResults[0];
        });
    }
    mounted() {
        store_1.default.actions.getResults();
        this.getUserName();
        this.storeResults();
    }
    getUserName() {
        if (!window.Student || typeof window.Student.getScope !== 'function') {
            console.warn('Results.getUserName: needed services not available.', window.Student);
            return;
        }
        window.Student.getScope('name').then((data) => {
            store_1.default.mutations.setUserName(data.name);
        }).catch(() => {
            console.warn('No student data available!');
        });
    }
    storeResults() {
        if (!window.Student || typeof window.Student.addInterests !== 'function') {
            console.warn('Results.storeResults: needed services not available.', window.Student);
            return;
        }
        window.Student.addInterests('country', this.topResults.value.map(result => result.id));
    }
}
exports.default = Results;
